// Article slug -> contextual media mapping (Nov 3 owner update).
// Product figures use the shared bottle assets (swapped to transparent cutouts when supplied);
// general guides use real lifestyle/community photos — no single-product effect claims.

export const PRODUCT_FIGURES = {
  "hydrate-plus": {
    name: "HYDRATE+", width: 800, height: 1025,
    src: "/images/products/hydrate-plus-cutout-800.png",
    alt: "HYDRATE+ watermelon, pineapple and lime cold-pressed juice bottle with clear protein, tiff. wellness co.",
    line: "Watermelon, pineapple and lime with added clear protein — $12 single.",
  },
  "citrus-drive": {
    name: "CITRUS DRIVE", width: 800, height: 1042,
    src: "/images/products/citrus-drive-cutout-800.png",
    alt: "CITRUS DRIVE orange, pineapple, carrot and ginger cold-pressed juice bottle with BCAAs, tiff. wellness co.",
    line: "Orange, pineapple, carrot and ginger with added BCAAs — $12 single.",
  },
  "flow-plus": {
    name: "FLOW+", width: 730, height: 1382,
    src: "/images/products/flow-plus-cutout-800.png",
    alt: "FLOW+ beet, red apple, lemon and ginger cold-pressed juice bottle with creatine, tiff. wellness co.",
    line: "Beet, red apple, lemon and ginger with added creatine — $12 single.",
  },
  "tropical-recovery": {
    name: "TROPICAL RECOVERY", width: 786, height: 1434,
    src: "/images/products/tropical-recovery-cutout-800.png",
    alt: "TROPICAL RECOVERY pineapple, mango, green apple and lime cold-pressed juice bottle with clear protein, tiff. wellness co.",
    line: "Pineapple, mango, green apple and lime with added clear protein — $12 single.",
  },
  "electric-sun": {
    name: "ELECTRIC SUN", width: 800, height: 1112,
    src: "/images/products/electric-sun-cutout-800.png",
    alt: "ELECTRIC SUN blue spirulina cold-pressed juice bottle with green apple, cucumber, pineapple, lemon and clear protein, tiff. wellness co.",
    line: "Green apple, cucumber, pineapple, lemon and blue spirulina with added clear protein — $12 single.",
  },
  "renew-plus": {
    name: "RENEW+", width: 800, height: 1076,
    src: "/images/products/renew-plus-cutout-800.png",
    alt: "RENEW+ cucumber, green apple, kiwi, lemon and lime cold-pressed juice bottle, tiff. wellness co.",
    line: "Cucumber, green apple, kiwi, lemon and lime — traditional, no added supplement, $10 single.",
  },
};

export const PHOTO_FIGURES = {
  "juice-case": {
    src: "/images/lifestyle/lifestyle-juice-case-1200.jpg", width: 1200, height: 1696,
    srcSmall: "/images/lifestyle/lifestyle-juice-case-768.webp",
    alt: "A case of Tiff Wellness Co. cold-pressed juice bottles on ice",
  },
  "bottles-on-ice": {
    src: "/images/lifestyle/lifestyle-bottles-on-ice-1200.jpg", width: 1200, height: 1631,
    srcSmall: "/images/lifestyle/lifestyle-bottles-on-ice-768.webp",
    alt: "Tiff Wellness Co. cold-pressed juice bottles on ice, Flow+ in front",
  },
  community: {
    src: "/images/tiff-wellness-community-original.jpg", width: 1254, height: 1254,
    srcSmall: "/images/tiff-wellness-community-original.webp",
    alt: "Runners and a Tiff. Wellness Co. juice table at a Dallas community track event",
  },
  editorial: {
    src: "/images/ingredient-editorial-1264.jpg", width: 1264, height: 848,
    srcSmall: "/images/ingredient-editorial-640.webp",
    alt: "Fresh fruit and vegetable juicing ingredients on a counter",
  },
};

// primary renders after body block 3; secondary (optional) after block 10.
export const ARTICLE_MEDIA = {
  "bcaa-juice-guide": { primary: { product: "citrus-drive", caption: "CITRUS DRIVE is our BCAA juice: orange, pineapple, carrot and ginger with added BCAAs." } },
  "beet-juice-flavor-guide": { primary: { product: "flow-plus", caption: "FLOW+ is our beet blend: beet, red apple, lemon and ginger with added creatine." } },
  "blue-spirulina-juice": { primary: { product: "electric-sun", caption: "ELECTRIC SUN gets its blue color from blue spirulina, blended with green apple, cucumber, pineapple and lemon." } },
  "build-mixed-juice-pack": {
    primary: { photo: "juice-case", caption: "A mixed case of tiff. juices packed on ice — any functional flavors can share 3-pack and 6-pack pricing." },
    secondary: { photo: "bottles-on-ice", caption: "Chilled bottles ready to go. Build any 1–24 bottle stack and prices are computed automatically." },
  },
  "citrus-ginger-juice": {
    primary: { product: "citrus-drive", caption: "CITRUS DRIVE pairs citrus with carrot and a warming note of ginger." },
    secondary: { product: "flow-plus", caption: "FLOW+ also uses ginger — alongside beet, red apple and lemon." },
  },
  "cold-pressed-juice-storage": { primary: { photo: "bottles-on-ice", caption: "Cold-pressed juice stays happiest cold: refrigerated, it's best enjoyed within 3–4 days." } },
  "cold-pressed-vs-regular-juice": { primary: { photo: "juice-case", caption: "A case of small-batch cold-pressed juices — no heat pasteurization step in the press itself." } },
  "compare-juice-prices-dallas": { primary: { photo: "juice-case", caption: "Tiff Wellness Co. functional juices are $12 single, $28 for 3 and $54 for 6 — mix and match flavors." } },
  "dallas-juice-buying-guide": {
    primary: { photo: "juice-case", caption: "A packed case of Dallas-made cold-pressed juice from tiff. wellness co." },
    secondary: { photo: "community", caption: "From a Dallas community track event where tiff. juices were sampled." },
  },
  "green-juice-dallas": {
    primary: { product: "renew-plus", caption: "RENEW+ is our traditional green juice — crisp cucumber, green apple, kiwi, lemon and lime, no added supplement." },
    secondary: { product: "electric-sun", caption: "ELECTRIC SUN takes the green-juice base in a different direction with blue spirulina and clear protein." },
  },
  "gym-juice-pickup-dallas": { primary: { photo: "community", caption: "tiff. wellness co. juices at a Dallas community event — pickup runs through SandersFit Dallas and South Side on Lamar." } },
  "juice-around-workouts": {
    primary: { product: "citrus-drive", caption: "CITRUS DRIVE — citrus and ginger with added BCAAs, an easy pre- or post-session option." },
    secondary: { product: "flow-plus", caption: "FLOW+ — beet and apple with added creatine, aimed at strength and high-intensity training days." },
  },
  "juice-cleanses-dallas-questions": { primary: { photo: "juice-case", caption: "We sell juice by the bottle and the stack — not cleanse programs with health promises." } },
  "juice-for-dallas-workweek": { primary: { photo: "bottles-on-ice", caption: "A week of bottles chilling — most people pick up once and refrigerate for 3–4 days of juice." } },
  "juice-for-small-gatherings": { primary: { photo: "juice-case", caption: "A case on ice is the simplest way to serve juice at a small gathering — bulk orders of 36 bottles are available by request." } },
  "juice-pickup-vs-delivery-dallas": { primary: { photo: "juice-case", caption: "Orders are packed cold for pickup at SandersFit Dallas or South Side on Lamar; DFW delivery is by arrangement." } },
  "juice-subscriptions-dallas": { primary: { photo: "bottles-on-ice", caption: "Subscriptions repeat your stack every 7 or 14 days with the same pickup coordination as one-time orders." } },
  "juice-vs-smoothie": { primary: { photo: "juice-case", caption: "Cold-pressed juice is pressed liquid without the blended fiber — a different product than a smoothie." } },
  "juice-with-clear-protein": {
    primary: { product: "hydrate-plus", caption: "HYDRATE+ — watermelon, pineapple and lime with added clear protein." },
    secondary: { product: "tropical-recovery", caption: "TROPICAL RECOVERY — pineapple, mango, green apple and lime, also made with clear protein." },
  },
  "juice-with-creatine": { primary: { product: "flow-plus", caption: "FLOW+ is our creatine juice: beet, red apple, lemon and ginger with added creatine." } },
  "local-juice-company-checklist": { primary: { photo: "community", caption: "tiff. wellness co. at a Dallas community event — small-batch and locally made." } },
  "organic-juice-companies-dallas": { primary: { photo: "juice-case", caption: "Fresh small-batch bottles from tiff. wellness co. — ask any juice company directly about sourcing claims." } },
  "pineapple-juice-blends": {
    primary: { product: "tropical-recovery", caption: "TROPICAL RECOVERY leads with pineapple and mango, plus green apple and lime." },
    secondary: { product: "citrus-drive", caption: "CITRUS DRIVE also uses pineapple to round out its orange, carrot and ginger base." },
  },
  "reading-juice-labels": { primary: { product: "electric-sun", caption: "ELECTRIC SUN's label lists exactly what's inside: green apple, cucumber, pineapple, lemon, blue spirulina and clear protein." } },
  "watermelon-juice-blends": { primary: { product: "hydrate-plus", caption: "HYDRATE+ is our watermelon blend — watermelon, pineapple and lime with added clear protein." } },
};

export const figureInfo = (m) => (m.product
  ? { ...PRODUCT_FIGURES[m.product], caption: m.caption, product: m.product }
  : { ...PHOTO_FIGURES[m.photo], caption: m.caption });

// In-body second image for articles without a mapped secondary.
export const EDITORIAL_FALLBACK = { photo: "editorial", caption: "Cold-pressed juice starts with whole fresh produce, pressed in small batches." };

// Article topic for BlogPosting `about` — the subject itself, since linked products are examples.
export const ARTICLE_TOPICS = {
  "bcaa-juice-guide": "BCAAs in juice",
  "beet-juice-flavor-guide": "Beet juice flavor",
  "blue-spirulina-juice": "Blue spirulina in juice",
  "build-mixed-juice-pack": "Building a mixed juice pack",
  "citrus-ginger-juice": "Citrus and ginger juice",
  "cold-pressed-juice-storage": "Cold-pressed juice storage",
  "cold-pressed-vs-regular-juice": "Cold-pressed vs regular juice",
  "compare-juice-prices-dallas": "Comparing juice prices in Dallas",
  "dallas-juice-buying-guide": "Buying cold-pressed juice in Dallas",
  "green-juice-dallas": "Green juice",
  "gym-juice-pickup-dallas": "Gym juice pickup in Dallas",
  "juice-around-workouts": "Juice around workouts",
  "juice-cleanses-dallas-questions": "Juice cleanse questions",
  "juice-for-dallas-workweek": "Juice for the workweek",
  "juice-for-small-gatherings": "Juice for small gatherings",
  "juice-pickup-vs-delivery-dallas": "Juice pickup vs delivery in Dallas",
  "juice-subscriptions-dallas": "Juice subscriptions in Dallas",
  "juice-vs-smoothie": "Juice vs smoothie",
  "juice-with-clear-protein": "Clear protein in juice",
  "juice-with-creatine": "Creatine in juice",
  "local-juice-company-checklist": "Choosing a local juice company",
  "organic-juice-companies-dallas": "Organic juice claims in Dallas",
  "pineapple-juice-blends": "Pineapple juice blends",
  "reading-juice-labels": "Reading juice labels",
  "watermelon-juice-blends": "Watermelon juice blends",
};
